export const POST_LOGIN_REDIRECT_KEY = 'postLoginRedirect'

/**
 * Reads and clears the path the user was heading for before being sent to the
 * login screen, so a link from another system survives logging in.
 */
export const takePostLoginRedirect = () => {
	try {
		const path = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY)
		sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY)
		// Only in-app paths, so a stored value can never send the user off-site.
		if (!path || !path.startsWith('/') || path.startsWith('//')) {
			return null
		}
		return path
	} catch (error) {
		console.error(error)
		return null
	}
}
